import { useLocation, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaWallet,
} from "react-icons/fa";
import moment from "moment";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getWalletWithdrawlRequestByID } from "./services/walletWithdrawal.services";
import { LoadingPanel } from "../../components/layout/Loading";

const WalletWithdrawalRequestView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const ID = location?.state?.ID;

  const loading = useAppSelector((state) => state.walletWithdrawal.loading);
  const WithdrawalRequestDetails = useAppSelector(
    (state) => state.walletWithdrawal.WithdrawalRequestDetails
  );

  useEffect(() => {
    dispatch(getWalletWithdrawlRequestByID(ID));
  }, []);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-link me-3"
            style={{
              color: "#00a34d",
              background: "white",
              padding: "8px",
            }}
          >
            <FaArrowLeft size={20} />
          </button>
          <h2 className="mb-0">Withdrawal Request Details</h2>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <span
                className="badge text-white py-2 px-3"
                style={{
                  backgroundColor:
                    WithdrawalRequestDetails.WithdrawlStatus === "Pending"
                      ? "goldenrod"
                      : WithdrawalRequestDetails.WithdrawlStatus === "Rejected"
                      ? "lightcoral"
                      : "#00a34de6",
                  fontSize: "0.9rem",
                }}
              >
                {WithdrawalRequestDetails.WithdrawlStatus}
              </span>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-4">
                  <h5 className="mb-3" style={{ color: "rgba(0, 163, 77, 1)" }}>
                    Transaction Details
                  </h5>

                  <div className="d-flex mb-3">
                    <div style={{ width: "150px" }}>
                      <p className="text-muted mb-0">Request Date</p>
                    </div>
                    <div>
                      <p className="mb-0 fw-bold">
                        {moment(
                          WithdrawalRequestDetails.RequestDate,
                          "DD/MM/YYYY HH:mm:ss"
                        ).format("DD MMM YYYY, hh:mm A")}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mb-3">
                    <div style={{ width: "150px" }}>
                      <p className="text-muted mb-0">Amount</p>
                    </div>
                    <div>
                      <p className="mb-0 fw-bold">
                        ₹{" "}
                        {WithdrawalRequestDetails.Amount?.toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                          }
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mb-3">
                    <div style={{ width: "150px" }}>
                      <p className="text-muted mb-0">Withdrawal Date</p>
                    </div>
                    <div>
                      <p className="mb-0 fw-bold">
                        {WithdrawalRequestDetails.WithdrawDate
                          ? moment(
                              WithdrawalRequestDetails.WithdrawDate,
                              "DD/MM/YYYY"
                            ).format("DD MMM YYYY")
                          : "-"}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex mb-3">
                    <div style={{ width: "150px" }}>
                      <p className="text-muted mb-0">Payment Method</p>
                    </div>
                    <div>
                      <p className="mb-0 fw-bold text-capitalize">
                        {WithdrawalRequestDetails?.PaymentType}
                      </p>
                    </div>
                  </div>

                  {/* Payment Method Details */}
                  {WithdrawalRequestDetails?.PaymentType === "UPI" ? (
                    <div className="d-flex mb-3">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">UPI Details</p>
                      </div>
                      <div>
                        <div className="d-flex align-items-center">
                          {/* {getUpiIcon()} */}
                          <p className="mb-0 fw-bold">
                            {WithdrawalRequestDetails?.UPIID}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : WithdrawalRequestDetails?.PaymentType === "Bank" ? (
                    <>
                      <div className="d-flex mb-3">
                        <div style={{ width: "150px" }}>
                          <p className="text-muted mb-0">Bank Name</p>
                        </div>
                        <div>
                          <p className="mb-0 fw-bold">
                            {WithdrawalRequestDetails?.BankName || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div style={{ width: "150px" }}>
                          <p className="text-muted mb-0">Account Number</p>
                        </div>
                        <div>
                          <p className="mb-0 fw-bold">
                            {WithdrawalRequestDetails?.AccountNo || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div style={{ width: "150px" }}>
                          <p className="text-muted mb-0">IFSC Code</p>
                        </div>
                        <div>
                          <p className="mb-0 fw-bold">
                            {WithdrawalRequestDetails?.IFSCCode || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div style={{ width: "150px" }}>
                          <p className="text-muted mb-0">Branch Name</p>
                        </div>
                        <div>
                          <p className="mb-0 fw-bold">
                            {WithdrawalRequestDetails?.BranchName || "-"}
                          </p>
                        </div>
                      </div>
                    </>
                  ) : null}

                  <div className="d-flex">
                    <div style={{ width: "150px" }}>
                      <p className="text-muted mb-0">Remarks</p>
                    </div>
                    <div>
                      <p className="mb-0">
                        {WithdrawalRequestDetails.Remarks || "-"}
                      </p>
                    </div>
                  </div>

                  {WithdrawalRequestDetails.WithdrawRemarks && (
                    <div className="d-flex mt-3">
                      <div style={{ width: "150px" }}>
                        <p className="text-muted mb-0">Admin Remarks</p>
                      </div>
                      <div>
                        <p className="mb-0">
                          {WithdrawalRequestDetails.WithdrawRemarks || "-"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Right column - User details */}
              <div className="col-md-6">
                <div className="mb-4">
                  <h5 className="mb-3" style={{ color: "rgba(0, 163, 77, 1)" }}>
                    User Details
                  </h5>

                  <div className="d-flex align-items-center mb-3">
                    <FaUser
                      className="me-2"
                      style={{ color: "rgba(205, 200, 36, 1)" }}
                    />
                    <p className="mb-0 fw-bold">
                      {WithdrawalRequestDetails.first_name}{" "}
                      {WithdrawalRequestDetails.last_name}
                    </p>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <FaPhone
                      className="me-2"
                      style={{ color: "rgba(205, 200, 36, 1)" }}
                    />
                    <p className="mb-0 fw-bold">
                      {WithdrawalRequestDetails.mobile_no}
                    </p>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <FaEnvelope
                      className="me-2"
                      style={{ color: "rgba(205, 200, 36, 1)" }}
                    />
                    <p className="mb-0 fw-bold">
                      {WithdrawalRequestDetails.email_id}
                    </p>
                  </div>
                </div>

                <div>
                  <h5 className="mb-3" style={{ color: "rgba(0, 163, 77, 1)" }}>
                    Wallet Details
                  </h5>

                  <div className="d-flex align-items-center mb-3">
                    <FaWallet
                      className="me-2"
                      style={{ color: "rgba(205, 200, 36, 1)" }}
                    />
                    <div>
                      <p className="mb-1 fw-bold">
                        ₹{" "}
                        {WithdrawalRequestDetails.wallet_balance?.toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                          }
                        )}
                      </p>
                      <p className="text-muted mb-0">
                        (Refundable: ₹{" "}
                        {WithdrawalRequestDetails.refundable_walletamount?.toLocaleString(
                          "en-IN"
                        )}{" "}
                        | Non-refundable: ₹{" "}
                        {WithdrawalRequestDetails.non_refundable_walletamount?.toLocaleString(
                          "en-IN"
                        )}
                        )
                      </p>
                    </div>
                  </div>

                  <div className="d-flex">
                    <div style={{ width: "150px" }}>
                      <p className="text-muted mb-0">Wallet Created On</p>
                    </div>
                    <div>
                      <p className="mb-0 fw-bold">
                        {moment(
                          WithdrawalRequestDetails.wallet_createdon,
                          "DD/MM/YYYY"
                        ).format("DD MMM YYYY")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletWithdrawalRequestView;
